/**
 * PORTED — RO-3-11 / #44304.
 * Origin: `excellent/app/database/sql/_client.tsx` (verbatim, minus the inert
 * `"use client"`).
 *
 * Zero `next/*` edges and zero server edges: `SqlEditor` and `DatabaseAssistant`
 * are `packages/ui` blocks that fetch their own data through the contracts, and
 * all four of those (`sql.run`, `snippets.list`, `snippets.save`,
 * `assistant.chat`) are mounted on the Hono host. So this page is fully live in
 * this shell today, including the audited read-only-by-default runner and the
 * AI assistant's propose-only loop.
 */

import * as React from "react";
import { SqlEditor, DatabaseAssistant, PageHeader, Card, Button } from "@excellent/ui";
import { Icon } from "@excellent/ui/icons";

/** SQL Editor workbench — a titled page header with the editor below, and the
 *  Assistant as a header-toggled docked panel (not a detached footer control). */
export function SqlWorkbench() {
  const [askOpen, setAskOpen] = React.useState(false);
  return (
    <div className="flex flex-col gap-4">
      <PageHeader
        title="SQL editor"
        description="Run SQL through the audited, read-only-by-default runner. ⌘/Ctrl+Enter to run."
        toolbar={
          <Button
            variant="outline"
            size="sm"
            onClick={() => setAskOpen((o) => !o)}
          >
            <Icon name="sparkles" size="sm" />
            {askOpen ? "Hide assistant" : "Ask AI about this data"}
          </Button>
        }
      />
      <SqlEditor />
      {askOpen ? (
        <Card className="max-h-[32rem] overflow-y-auto p-4">
          <DatabaseAssistant mode="panel" />
        </Card>
      ) : null}
    </div>
  );
}
